// const baseUrl =  ("http://localhost:4040/v1")
// const GraphUrl = "http://localhost:4000/graphql";
// const PushUrl = "http://localhost:4000";
// const GraphSubsUrl = 'ws://localhost:4000/graphql'

const baseUrl = "https://api.dhuhaenergy.ir/v1";
const GraphUrl = "https://gql.tepaya.ir/graphql"
const PushUrl = "https://gql.tepaya.ir";

export {
  baseUrl,
  GraphUrl,
  PushUrl,
  // GraphSubsUrl
};
